import { h, tag } from "omi";
import { RouterLocation } from "@vaadin/router";

import { PureComponent } from "@/utils/pureComponent";
import { AppLayout } from "@/appLayout";
import { NWSuspense } from "@/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

import { installProject } from "../project/install";
import { PagesPortfolioHome } from "./pages/home";
import { PortfolioStore } from "./store";

type Props = {
  standalone?: boolean;
};

type RouteParams = {
  nickname: string;
};

@tag("pages-portfolio")
export class PagesPortfolio extends PureComponent<Props> {
  static css = [tailwind];

  onBeforeEnter(location: RouterLocation<RouteParams>) {
    const nickname = location.params.nickname as string | undefined;
    this.setupPage(nickname);
  }

  installed() {
    if (this.props.standalone) {
      this.setupPage();
    }
  }

  private setupPage(nickname?: string) {
    const isPortfolioEnabled = Store.features.hasFeature("app.portfolio");

    if (!isPortfolioEnabled) {
      return;
    }

    PortfolioStore.setViewingOptions(nickname);
    PortfolioStore.fetch();
  }

  render() {
    if (this.props.standalone) {
      // Standalone mode, render the home page directly without subpage routing, might change this later as cross-linking between projects is required.
      return <PagesPortfolioHome />;
    }

    return (
      <AppLayout>
        <div slot="panel">
          {/* Router injects subpages here */}
          <slot></slot>
        </div>
        <NWSuspense
          slot="main"
          loadFunc={installProject}
          onLoadComplete={PagesProject => <PagesProject standalone />}
        />
      </AppLayout>
    );
  }
}
